import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {ReservationService} from "app/services";
import {filterSchedules} from "./filter-schedules.slice";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {AddPaymentsTypes} from "app/types/service-types/ReservationTypes";
import store from "../../../store";

interface AddPaymentsParams {
  id: string;
  body: AddPaymentsTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const addPayment =
    (params: AddPaymentsParams) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.addPayment(
            params.id,
            params.body
        );


        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Payment registered successfully!' : 'Pagesa u regjistrua me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err: any) {
        const isEnglish = localStorage.getItem('i18nextLng') === 'en';
        const message = err?.data?.message || err?.response?.data?.message ||
            (isEnglish ? 'Payment could not be registered.' : 'Pagesa nuk mund të regjistrohej.');
        const invalidAmount = message.startsWith('Invalid Payment amount:');
        const amount = message.split(' ').pop();
        dispatch(setLoading(false));
        dispatch(setSuccess(false));
        dispatch(errorMsg(invalidAmount
            ? (isEnglish ? 'Invalid payment amount: '+amount+'!' : 'Shuma e pageses: '+amount+' eshte jo valide!')
            : message));
        if (params.onError) params.onError();
        dispatch(setError(message));
      }
    };

interface AddPaymentsSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: AddPaymentsSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/payments",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
